import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './Hero.css';
import foto1 from '../assets/foto2.webp'; // Business man
import foto2 from '../assets/office-multi-hero.webp'; // Business woman likely
import { MdStar, MdCheckCircle } from 'react-icons/md';

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero-container">

        {/* Left Side: Text Content */}
        <div className="hero-text-content">
          <motion.div
            className="hero-badge-top"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span>🚀 2025 Digital Solutions</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {t('hero.title')}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            {t('hero.subtitle')}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
            className="hero-actions"
          >
            <Link to="/kontakt" className="hero-cta-button primary">
              {t('hero.cta_button')}
            </Link>
            <Link to="/leistungen" className="hero-cta-button secondary">
              {t('hero.secondary_button')}
            </Link>
          </motion.div>
        </div>

        {/* Right Side: Vector & Image Composition */}
        <motion.div
          className="hero-visuals"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          {/* Main Shape 1 with Image */}
          <div className="hero-shape-card shape-1">
            <div className="shape-bg blob-cyan"></div>
            <img src={foto1} alt="Consultant" className="hero-person-img" />

            {/* Floating Badge 1 */}
            <motion.div
              className="float-badge badge-1"
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            >
              <div className="badge-icon icon-yellow"><MdStar /></div>
              <div className="badge-text">
                <strong>4.9 Rating</strong>
                <span>Top Service</span>
              </div>
            </motion.div>
          </div>

          {/* Main Shape 2 with Image */}
          <div className="hero-shape-card shape-2">
            <div className="shape-bg blob-purple"></div>
            <img src={foto2} alt="Developer" className="hero-person-img" />

            {/* Floating Badge 2 */}
            <motion.div
              className="float-badge badge-2"
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
            >
              <div className="badge-icon icon-green"><MdCheckCircle /></div>
              <div className="badge-text">
                <strong>Verified</strong>
                <span>Expert Team</span>
              </div>
            </motion.div>
          </div>
        </motion.div>

      </div>
    </section>
  );
}

export default Hero;